/* Pooch — header ka behaviour + offer bar ka countdown.
   Koi markup nahi badla, sirf class add hoti hai aur text me token replace hota hai.

   COUNTDOWN — client khud chalata hai:
   Customize -> Announcement bar -> text me ye likh do:
       Sale ends in [countdown:2026-10-05 23:59]
   Date nikal do to timer apne aap gayab. Format: YYYY-MM-DD HH:MM (24 hour).   */
(function () {
  var RXWS = new RegExp(String.fromCharCode(92)+"s+","g");

  /* ---------- 1. scroll par header patla ---------- */
  function header() {
    var h = document.querySelector('[id*="__header_section"]');
    if (!h) return;
    var last = null;
    function onScroll() {
      var small = window.scrollY > 70;
      if (small === last) return;
      last = small;
      h.classList.toggle('pooch-shrunk', small);
      document.documentElement.classList.toggle('pooch-scrolled', small);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 2. offer bar ka countdown ---------- */
  var TOKEN = /\[countdown:\s*(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?\s*\]/i;

  function two(n) { return n < 10 ? '0' + n : '' + n; }

  function build(target, node, raw) {
    var span = document.createElement('span');
    span.className = 'pooch-countdown';
    node.textContent = raw.replace(TOKEN, '\u0000');
    var parts = node.textContent.split('\u0000');
    node.textContent = parts[0];
    var tail = document.createTextNode(parts[1] || '');
    node.parentNode.insertBefore(span, node.nextSibling);
    node.parentNode.insertBefore(tail, span.nextSibling);

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) { span.textContent = ''; span.classList.add('is-over'); return; }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var hh = Math.floor(s / 3600); s -= hh * 3600;
      var mm = Math.floor(s / 60); s -= mm * 60;
      span.textContent = (d > 0 ? d + 'd ' : '') + two(hh) + ':' + two(mm) + ':' + two(s);
      setTimeout(tick, 1000);
    }
    tick();
  }

  function countdown(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var hits = [], n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue && TOKEN.test(n.nodeValue)) hits.push(n);
    }
    hits.forEach(function (node) {
      var raw = node.nodeValue;
      var m = raw.match(TOKEN);
      if (!m) return;
      var t = new Date(
        +m[1], (+m[2]) - 1, +m[3],
        m[4] ? +m[4] : 23, m[5] ? +m[5] : 59, 0
      ).getTime();
      if (isNaN(t)) return;
      build(t, node, raw);
    });
  }


  /* ---------- 3. stagger: ek group ke items ek saath nahi, 90ms ke gap se ---------- */
  function poochStagger() {
    /* har baar poora group dobara banate hain — pehle marked items ko skip karne se
       baad wale group chhote pad jaate the aur delay lagta hi nahi tha */
    var groups = new Map();
    document.querySelectorAll('.pooch-stg-item').forEach(function (el) {
      var p = el.parentElement; if (!p) return;
      if (!groups.has(p)) groups.set(p, []);
      groups.get(p).push(el);
    });
    groups.forEach(function (items) {
      if (items.length < 2) return;
      items.forEach(function (el, i) {
        var d = Math.min(i, 6) * 90;
        if (el.dataset.poochStg === String(d)) return;
        el.dataset.poochStg = String(d);
        el.style.setProperty('transition-delay', d + 'ms', 'important');
      });
    });
  }

  /* ---------- 4. hero heading: aakhri 2 shabd accent me ----------
     Text hardcode NAHI hai. Client Customize me text badlega to ye
     naye text ke aakhri 2 shabd apne aap accent kar dega. */
  function heroSplit() {
    document.querySelectorAll("[id*='__hero_slideshow'] .slide__content [class*='text-block'] > h1, [id*='__hero_slideshow'] .slide__content [class*='text-block'] > h2, [id*='__hero_slideshow'] .slide__content [class*='text-block'] > h3").forEach(function (h) {
      var raw = (h.textContent || '').replace(RXWS, " ").trim();
      if (!raw || h.dataset.poochHero === raw) return;
      h.dataset.poochHero = raw;
      var w = raw.split(' ');
      if (w.length < 3) { h.textContent = raw; return; }
      var n = w.length > 5 ? 2 : 1;
      /* pehla hissa bhi apne span me daalte hai - warna heading ki apni patti
         golden wali line ke peeche se jhaankti hai aur hari border ban jati hai */
      h.textContent = '';
      var base = document.createElement('span');
      base.className = 'pooch-hero-base';
      base.textContent = w.slice(0, w.length - n).join(' ') + ' ';
      h.appendChild(base);
      var sp = document.createElement('span');
      sp.className = 'pooch-hero-accent';
      sp.textContent = w.slice(w.length - n).join(' ');
      h.appendChild(sp);
      h.dataset.poochHero = (h.textContent || '').replace(RXWS, " ").trim();
    });
  }
  function run() {
    header();
    heroSplit();
    poochStagger();
    var bar = document.querySelector('[id*="header_announcements"]');
    if (bar && bar.dataset.poochCd !== '1') { bar.dataset.poochCd = '1'; countdown(bar); }
  }

  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', function () {
    var bar = document.querySelector('[id*="header_announcements"]');
    if (bar) bar.dataset.poochCd = '';
    run();
  });
  new MutationObserver(function(){ clearTimeout(window.__poochStgT); window.__poochStgT=setTimeout(function(){poochStagger();heroSplit();},300); })
    .observe(document.documentElement,{childList:true,subtree:true});
  run();
})();
